import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query BlogSeoAnalysis($projectId: ID!, $draftId: ID!) {
    blogSeoAnalysis(projectId: $projectId, draftId: $draftId) {
      status
      data {
        keywords
        wordCountRange
        paragraphRange
        headlineRange
      }
    }
  }
`;

export const queryBlogSeoAnalysis = (projectId, draftId) =>
  executeGqlQuery({
    query: QUERY,
    variables: {
      projectId,
      draftId,
    },
  }).then(({ data }) => getSingleProp(data));
